import { useQuery } from '@tanstack/react-query';

import { RESERVATION_TYPE, type ReservationType } from 'src/features/reservations/types/reservationType.ts';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';

interface DTO {
    parkingId?: string;
    reservationType?: RESERVATION_TYPE;
    includeDisabled?: boolean;
}

type ReservationTypeListQueryFnType = typeof getReservationTypeCurrentVersion;

interface UseReservationTypeList extends DTO {
    config?: QueryConfig<ReservationTypeListQueryFnType>;
}

export const getReservationTypeCurrentVersion = ({
    parkingId,
    reservationType,
    includeDisabled,
}: DTO): Promise<ReservationType> => {
    return axios.get(
        `/reservations/${parkingId}/vehicle-stay-reservation-type/current-version?type=${reservationType}&include_disabled=${includeDisabled}`,
    );
};

export const useReservationTypeCurrentVersion = ({ config, ...payload }: UseReservationTypeList) => {
    const { parkingId, reservationType } = payload;
    return useQuery({
        queryKey: ['vehicle-stay-reservation-type-current-version', parkingId, reservationType],
        queryFn: async () => await getReservationTypeCurrentVersion(payload),
        enabled: !!reservationType,
        ...config,
    });
};
